/**
 * Honeypot field helper. Hidden form field that real visitors never
 * see (display:none + aria-hidden + tabIndex=-1 + autoComplete=off)
 * but most bots fill in because they auto-populate every form input
 * they can find.
 *
 * Usage in a component:
 *   const [honeypot, setHoneypot] = useState('');
 *   // in the form:
 *   <HoneypotField value={honeypot} onChange={setHoneypot} />
 *   // in the submit handler:
 *   if (isHoneypotTripped(honeypot)) {
 *     // Pretend success — silently skip the API call so bots can't
 *     // probe for whether the honeypot blocked them.
 *     setSubmitted(true);
 *     return;
 *   }
 *
 * The field name "company_url" is chosen because that's a high-value
 * label bots will eagerly fill (it looks like a legitimate B2B form
 * field). If you ever rename it, rename everywhere — bots cache
 * field names per-domain.
 */

import React from 'react';

export const HONEYPOT_FIELD_NAME = 'company_url';

export const isHoneypotTripped = (value: string): boolean =>
  value.trim().length > 0;

interface HoneypotFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export const HoneypotField = ({ value, onChange }: HoneypotFieldProps) => (
  <input
    type="text"
    name={HONEYPOT_FIELD_NAME}
    autoComplete="off"
    tabIndex={-1}
    aria-hidden="true"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    style={{ display: 'none' }}
  />
);
